<template>
  <div class="cp-section">
    <div v-if="!processing && !isCPLoading" class="cp-section__list">
      <div class="cp-section__container">
        <b-card class="cp__card cp__form">
          <div class="cp__form__header">
            <p class="cp__form__header__title">My Information</p>
            <div class="cp__form__edit__icon" @click.stop="toggleUpdate()">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M13.2633 5.43908L5.05327 14.1291C4.74327 14.4591 4.44327 15.1091 4.38327 15.5591L4.01327 18.7991C3.88327 19.9691 4.72327 20.7691 5.88327 20.5691L9.10327 20.0191C9.55327 19.9391 10.1833 19.6091 10.4933 19.2691L18.7033 10.5791C20.1233 9.07908 20.7633 7.36908 18.5533 5.27908C16.3533 3.20908 14.6833 3.93908 13.2633 5.43908Z" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M11.8931 6.89062C12.3231 9.65062 14.5631 11.7606 17.3431 12.0406" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
          </div>
          <div class="cp__form__body">
            <div class="cp__form__field">
              <label class="cp__form__field__label">First name</label>
              <div class="cp__form__field__value">
                <span class="text-ellipses">{{displayCustomer.first_name}}</span>
              </div>
            </div>
            <div class="cp__form__field">
              <label class="cp__form__field__label">Last name</label>
              <div class="cp__form__field__value">
                <span class="text-ellipses">{{displayCustomer.last_name}}</span>
              </div>
            </div>
            <div class="cp__form__field">
              <label class="cp__form__field__label">Phone</label>
              <div class="cp__form__field__value">
                <span class="text-ellipses">{{displayCustomer.phone}}</span>
              </div>
            </div>
            <div class="cp__form__field">
              <label class="cp__form__field__label">Email</label>
              <div class="cp__form__field__value">
                <span class="text-ellipses">{{displayCustomer.email}}</span>
              </div>
            </div>
            <div class="cp__form__field">
              <label class="cp__form__field__label">Address</label>
              <div class="cp__form__field__value">
                <span class="text-ellipses">{{displayCustomer.address1}}</span>
              </div>
            </div>
            <div class="cp__form__field">
              <label class="cp__form__field__label">Country</label>
              <div class="cp__form__field__value">
                <span class="text-ellipses">USA</span>
              </div>
            </div>
            <div class="cp__form__field">
              <label class="cp__form__field__label">City</label>
              <div class="cp__form__field__value">
                <span class="text-ellipses">{{displayCustomer.city}}</span>
              </div>
            </div>
            <div class="cp__form__field">
              <label class="cp__form__field__label">Province/State</label>
              <div class="cp__form__field__value">
                <span class="text-ellipses">{{state}}</span>
              </div>
            </div>
            <div class="cp__form__field mb-0">
              <label class="cp__form__field__label">Postal Code</label>
              <div class="cp__form__field__value">
                <span class="text-ellipses">{{displayCustomer.zip}}</span>
              </div>
            </div>
          </div>
        </b-card>
        <b-card class="cp__card cp__form" v-if="paymentSource">
          <div class="cp__form__header">
            <p class="cp__form__header__title">Payment Method</p>
            <div class="cp__form__edit__icon" @click.stop="$emit('submit')">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M13.2633 5.43908L5.05327 14.1291C4.74327 14.4591 4.44327 15.1091 4.38327 15.5591L4.01327 18.7991C3.88327 19.9691 4.72327 20.7691 5.88327 20.5691L9.10327 20.0191C9.55327 19.9391 10.1833 19.6091 10.4933 19.2691L18.7033 10.5791C20.1233 9.07908 20.7633 7.36908 18.5533 5.27908C16.3533 3.20908 14.6833 3.93908 13.2633 5.43908Z" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M11.8931 6.89062C12.3231 9.65062 14.5631 11.7606 17.3431 12.0406" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
          </div>
          <div class="cp__form__body">
            <div class="cp__form__field w-100 ml-0 mb-0">
              <div class="cp__form__field__value mb-0">
                <img class="left-icon mr-2" :src="require(`@/assets/images/${(getCardIcon(paymentSource.type.toLowerCase()))}.svg`)" alt=""/>
                <p class="mb-0 pi__number"> **** {{paymentSource.last4}}</p>
                <b-badge class="cp__card__badge pi__badge" v-if="paymentSource.isDefault">Default</b-badge>
              </div>
            </div>
          </div>
        </b-card>
        <b-sidebar
          no-header
          backdrop
          shadow
          :class="{'show': enableUpdate, 'd-none': !enableUpdate}"
          sidebar-class="cp-sidebar full-height"
          body-class="cp-sidebar__body"
          v-model="enableUpdate"
          @change="toggleScrollbar()"
        >
          <SidebarHeader :title="'My Information'" @clear="toggleUpdate() && toggleScrollbar()" />
          <div class="cp-sidebar__main">
            <b-form class="cp__form w-100" @submit.prevent="updateInformation()">
              <div class="cp__form__field__wrapper">
                <b-form-group class="cp__form__field form__input" label-class="cp__form__field__label" label="First name" label-for="first_name">
                  <b-form-input id="first_name" type="text" v-model.trim="customer.first_name" placeholder="First name"
                                class="customer checkout-form-input"></b-form-input>
                  <div v-if="errors.first_name" class="text-danger input-error text-right pr-1">
                    <small>{{ errors.first_name }}</small>
                  </div>
                </b-form-group>
                <b-form-group class="cp__form__field form__input" label-class="cp__form__field__label" label="Last name" label-for="last_name">
                  <b-form-input id="last_name" type="text" v-model.trim="customer.last_name" placeholder="Last name"
                                class="customer checkout-form-input"></b-form-input>
                  <div v-if="errors.last_name" class="text-danger input-error text-right pr-1">
                    <small>{{ errors.last_name }}</small>
                  </div>
                </b-form-group>
              </div>
              <b-form-group class="cp__form__field form__input disabled-form-group" label-class="cp__form__field__label" label="Phone number" label-for="phone_number">
                <b-form-input id="phone_number" type="text" v-model.trim="customer.phone" placeholder="Phone Number"
                              class="customer checkout-form-input" disabled></b-form-input>
                <div v-if="errors.phone" class="text-danger input-error text-right pr-1">
                  <small>{{ errors.phone }}</small>
                </div>
              </b-form-group>
              <b-form-group class="cp__form__field form__input disabled-form-group" label-class="cp__form__field__label" label="Email" label-for="email">
                <b-form-input id="email" type="email" v-model.trim="customer.email" placeholder="Email"
                              class="customer checkout-form-input" disabled></b-form-input>
                <div v-if="errors.email" class="text-danger input-error text-right pr-1">
                  <small>{{ errors.email }}</small>
                </div>
              </b-form-group>
              <b-form-group class="cp__form__field form__input" label-class="cp__form__field__label" label="Address 1" label-for="address1">
                <b-form-input id="address1" type="text" v-model.trim="customer.address1" placeholder="Address 1"
                              class="customer checkout-form-input"></b-form-input>
                <div v-if="errors.address1" class="text-danger input-error text-right pr-1">
                  <small>{{ errors.address1 }}</small>
                </div>
              </b-form-group>
              <b-form-group class="cp__form__field form__input" label-class="cp__form__field__label" label="City" label-for="city">
                <b-form-input id="city" type="text" v-model.trim="customer.city" placeholder="City"
                              class="customer checkout-form-input"></b-form-input>
                <div v-if="errors.city" class="text-danger input-error text-right pr-1">
                  <small>{{ errors.city }}</small>
                </div>
              </b-form-group>
              <div class="cp__form__field__wrapper">
                <b-form-group class="cp__form__field form__input" label-class="cp__form__field__label" label="Province/State" label-for="state">
                  <b-form-select id="state" v-model="customer.state" :options="states" placeholder="State"
                                 class="customer checkout-form-input"></b-form-select>
                  <div v-if="errors.state" class="text-danger input-error text-right pr-1">
                    <small>{{ errors.state }}</small>
                  </div>
                </b-form-group>
                <b-form-group class="cp__form__field form__input" label-class="cp__form__field__label" label="Postal Code" label-for="postal_code">
                  <b-form-input id="postal_code" type="text" v-model.trim="customer.zip" placeholder="Postal Code"
                                class="customer checkout-form-input"></b-form-input>
                  <div v-if="errors.zip" class="text-danger input-error text-right pr-1">
                    <small>{{ errors.zip }}</small>
                  </div>
                </b-form-group>
              </div>
              <b-button type="submit" class="cp-sidebar__btn no-outline-btn" variant="primary">
                Update & Save
              </b-button>
            </b-form>
          </div>
        </b-sidebar>
      </div>
    </div>
    <ProcessingLoader v-else />
  </div>
</template>

<script>

import {mapState} from 'vuex'
import {Regions} from '@/constants'
import {getStates, toggleBodyScrollbar} from '@/utils'
import axios from 'axios'
import ProcessingLoader from '@/components/ProcessingLoader'
import SidebarHeader from '@/components/Sidebar/SidebarHeader'

export default {
  name: 'CustomerPortalPersonalInfo',
  components: {SidebarHeader, ProcessingLoader},
  props: {
    input: Object
  },
  data: function() {
    return {
      processing: true,
      customer: {
        address1: null,
        address2: null,
        city: null,
        state: null,
        zip: null,
        first_name: null,
        last_name: null,
        email: null,
        phone: null,
        country: 'US'
      },
      paymentSource: null,
      enableUpdate: false,
      errors: {},
      displayCustomer: {}
    }
  },
  computed: {
    ...mapState(['session', 'campaign', 'isCPLoading']),
    state: function() {
      if (Regions[this.displayCustomer.country]) {
        const state = Regions[this.customer.country].find((state) => state.value === this.displayCustomer.state)
        if (state) {
          return state.text
        }
      }
      return this.customer.state
    },
    states: function() {
      if (this.campaign) {
        return getStates(this.campaign, this.customer.country)
      }
      return []
    }
  },
  methods: {
    toggleScrollbar: function() {
      toggleBodyScrollbar(this.enableUpdate)
      this.$emit('clear')
    },
    toggleUpdate: function() {
      this.enableUpdate = !this.enableUpdate
    },
    getCardIcon: function(brand) {
      let cardBrandToClass = {
        'jcb': 'jcb',
        'amex': 'amex',
        'visa': 'visa',
        'unknown': 'credit-card',
        'discover': 'discover',
        'diners': 'diners',
        'mastercard': 'mastercard'
      }
      brand = cardBrandToClass[brand] ? brand : 'unknown'
      return cardBrandToClass[brand]
    },
    isInvalid: function() {
      this.errors = {}
      let hasError = false
      const letter = '[a-zA-Z][a-zA-Z ]+'

      if (this.customer['first_name'] !== null) {
        if (this.customer['first_name'].match(letter)) {
          this.errors.first_name = null
        } else {
          this.errors.first_name = 'This field is required'
        }
      }

      if (this.customer['last_name'] !== null) {
        if (this.customer['last_name'].match(letter)) {
          this.errors.last_name = null
        } else {
          this.errors.last_name = 'This field is required'
        }
      }

      let requiredFields = [
        'address1',
        'city',
        'state',
        'zip'
      ]
      let existingFieldsErrors = {...this.errors}
      requiredFields.forEach(field => {
        let value = this.customer[field]
        existingFieldsErrors[field] = null
        if (!value || value.length < 1) {
          existingFieldsErrors[field] = 'This field is required.'
          hasError = true
        }
      })
      this.errors = existingFieldsErrors

      return hasError
    },
    updateInformation: function() {
      if (!this.isInvalid()) {
        this.$store.commit('showCPLoader')
        this.$store.dispatch('update_customer', this.customer)
          .then((customer) => {
            Object.keys(this.customer).forEach(key => {
              this.displayCustomer[key] = customer[key]
            })
          })
          .catch(err => {
            if (err.response.status === 400) {
              this.$store.commit('error', err)
            } else {
              this.$store.commit('critical_error', err)
            }
          })
          .finally(() => {
            this.toggleUpdate()
            this.toggleScrollbar()
            this.$store.commit('hideCPLoader')
          })
      }
    }
  },
  created() {
    Object.keys(this.customer).forEach(key => {
      this.customer[key] = this.session.customer[key]
      this.displayCustomer[key] = this.session.customer[key]
    })
    if (this.session.customer.default_payment_source) {
      this.processing = true
      this.paymentSource = null
      axios.get(`/payment_sources/${this.session.customer.default_payment_source}/`)
        .then((response) => {
          const source = response.data
          this.paymentSource = {
            id: source.id,
            isDefault: source.is_default,
            type: source.cc_type,
            last4: source.cc_last4
          }
        })
        .catch(err => this.$store.commit('critical_error', err))
        .finally(() => {
          this.processing = false
        })
    } else {
      this.processing = false
    }
  }
}
</script>

<style scoped>

</style>
